import { render, staticRenderFns } from "./TruncateString.vue?vue&type=template&id=a915070a&scoped=true&"
import script from "./TruncateString.vue?vue&type=script&lang=js&"
export * from "./TruncateString.vue?vue&type=script&lang=js&"
import style0 from "./TruncateString.vue?vue&type=style&index=0&id=a915070a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a915070a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a915070a')) {
      api.createRecord('a915070a', component.options)
    } else {
      api.reload('a915070a', component.options)
    }
    module.hot.accept("./TruncateString.vue?vue&type=template&id=a915070a&scoped=true&", function () {
      api.rerender('a915070a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/TruncateString.vue"
export default component.exports